import React, { Component } from "react";

class VerbChooser extends Component {
    verbChange(event) {
        this.props.onChangeVerb(event.target.value);
    }

    render() {
        return(
            <div className="form-group row">
                <label 
                    className="col-sm-4 col-form-label"
                    htmlFor="verbSelect">
                    { "Verb: " }
                </label>
                <input
                    name="verb"
                    id="verbSelect"
                    className="verb col-sm-7 form-control"
                    value={ this.props.verb }
                    onChange={ this.verbChange.bind(this) }
                    type="text"
                    placeholder="e.g. take, cost, score, win, yield"
                />
            </div>
        );
    }
}

export default VerbChooser;


// WEBPACK FOOTER //
// ./src/components/VerbChooser.js